import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, UiButton, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {WEIGHT_LOSS_KEYS} from '~/constants/medical-questionnaires';
import {useInput} from '~/hooks';
import {setQuestionnaireAnswer, setNextQuestionnaire} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';

const Questionnaire15Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === WEIGHT_LOSS_KEYS.DESCRIBE_CURRENT_EATING_HABITS);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[WEIGHT_LOSS_KEYS.DESCRIBE_CURRENT_EATING_HABITS]?.data,
  );

  const {inputs, setInputs} = useInput({
    selectedOption: currentAnswer?.selectedOption || '',
  });
  const onClickSubmit = () => {
    dispatch(
      setQuestionnaireAnswer({
        key: WEIGHT_LOSS_KEYS.DESCRIBE_CURRENT_EATING_HABITS,
        index: questionnaire?.index || '',
        data: inputs,
      }),
    );
    dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.TAKE_WEIGHT_LOSS_MEDICATION_BEFORE}));
  };
  return (
    <UiQuestionnaireLayout
      backIcon
      handleOnNext={onClickSubmit}
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      disableNext={!inputs?.selectedOption}
    >
      <Col textAlign="center">
        <UiText variant="mdqTitle" my={10}>
          {questionnaire?.questions?.default}
        </UiText>
        {questionnaire?.options?.map(value => (
          <UiButton
            onClick={() => setInputs({selectedOption: value?.value})}
            key={`${value.label}-${value.value}`}
            title={value?.label}
            mb={4}
            variant={inputs?.selectedOption === value.value ? 'solid' : 'toggle'}
            minH="64px"
          />
        ))}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire15Screen;
